import styled from "styled-components";

export const Container = styled.div<{ maxWidth?: string }>`
  position: relative;
  flex: 1;
  max-width: ${({ maxWidth }) => maxWidth || "50%"};
`;

export const RaceItem = styled.li`
  display: flex;
  align-items: center;
  padding: ${({ theme }) =>
    `${theme.space["space-3"]} ${theme.space["space-5"]}`};
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  height: 45px;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};

  &:hover {
    background-color: ${({ theme }) => theme.colorTokens.background.hover};
  }
`;
